import React, { ReactNode } from 'react';

interface CourseInfoBoxProps {
  header: string;
  description: string;
  className?: string;
  children?: ReactNode;
}

const CourseInfoBox = ({ className = '', header, description, children }: CourseInfoBoxProps) => {
  return (
    <div className={`bg-cultured p-5 ${className}`}>
      <h3 className='text-deepspace font-raleway text-center text-3xl mt-4'>{header}</h3>
      <p className='my-2 font-raleway text-lg text-center'>{description}</p>
      {children}
    </div>
  );
};

export default CourseInfoBox;
